import type { ReactNode } from 'react';

import type { ErrorsEmitter } from '@realadvisor/error';
import { RelayEnvironmentProvider } from 'react-relay';
import type { IEnvironment } from 'relay-runtime';
import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import * as config from '@shared/config';
import {
  extractLanguageFromUrl,
  fallbackLanguage,
} from '@shared/LocaleContext';

import { errorsEmitter } from './ApolloHasuraWrapper';
import { createFetchQuery } from './relay-fetch';

const getTimeZoneId = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

let relayApiEnvironment: null | IEnvironment = null;

const createEnvironment = ({
  endpoint,
  errorsEmitter,
}: {
  endpoint: string;
  errorsEmitter: ErrorsEmitter;
}): IEnvironment =>
  new Environment({
    network: Network.create(
      createFetchQuery({
        endpoint,
        errorsEmitter,
        // Unchanged from before the extraction, including that it reads the
        // API environment for both endpoints.
        getRecordSource: () => relayApiEnvironment?.getStore().getSource(),
      }),
    ),
    store: new Store(new RecordSource()),
  });

type Props = {
  children: ReactNode;
};

export const RelayApiWrapper = (props: Props) => {
  if (relayApiEnvironment == null) {
    const lng = extractLanguageFromUrl() ?? fallbackLanguage;
    const tz = getTimeZoneId();
    const endpoint = `${config.api_origin}/graphql?lng=${lng}&tz=${tz}`;
    relayApiEnvironment = createEnvironment({
      endpoint,
      errorsEmitter,
    });
  }
  return (
    <RelayEnvironmentProvider environment={relayApiEnvironment}>
      {props.children}
    </RelayEnvironmentProvider>
  );
};

let relayHasuraEnvironment: null | IEnvironment = null;
export const RelayHasuraWrapper = (props: Props) => {
  if (relayHasuraEnvironment == null) {
    const tz = getTimeZoneId() ?? '';
    const endpoint = `${config.hasura_origin}/v1beta1/relay?tz=${tz}`;
    relayHasuraEnvironment = createEnvironment({
      endpoint,
      errorsEmitter,
    });
  }
  return (
    <RelayEnvironmentProvider environment={relayHasuraEnvironment}>
      {props.children}
    </RelayEnvironmentProvider>
  );
};
